/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface FileMetaInfoDto
 */
export interface FileMetaInfoDto {
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetaInfoDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileMetaInfoDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetaInfoDto
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    blobContainerName?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof FileMetaInfoDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof FileMetaInfoDto
     */
    $type?: FileMetaInfoDtoTypeEnum;
}


/**
 * @export
 */
export const FileMetaInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonFilesFileMetaInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Files.FileMetaInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type FileMetaInfoDtoTypeEnum = typeof FileMetaInfoDtoTypeEnum[keyof typeof FileMetaInfoDtoTypeEnum];



/**
 * Check if a given object implements the FileMetaInfoDto interface.
 */
export function instanceOfFileMetaInfoDto(value?: unknown): value is FileMetaInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(FileMetaInfoDtoTypeEnum)[0];
}

export function FileMetaInfoDtoFromJSON(json: any): FileMetaInfoDto {
    return FileMetaInfoDtoFromJSONTyped(json, false);
}

export function FileMetaInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileMetaInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'name': json['name'],
        'type': json['type'],
        'size': json['size'] == null ? undefined : json['size'],
        'blobContainerName': json['blobContainerName'] == null ? undefined : json['blobContainerName'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function FileMetaInfoDtoToJSON(value?: Omit<FileMetaInfoDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'name': value['name'],
        'type': value['type'],
        'size': value['size'],
        'blobContainerName': value['blobContainerName'],
        'origin': EntityOriginToJSON(value['origin']),
        '$type': value['$type'],
    });
}

